import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  alert: {
    color: t.red01,
  },

  alertMessage: {
    color: t.red01,
    fontSize: '0.875rem',
  },
}))

export default useStyles
